import { render } from "./SummaryFreemium.vue?vue&type=template&id=1f51a244&scoped=true"
import script from "./SummaryFreemium.vue?vue&type=script&lang=js"
export * from "./SummaryFreemium.vue?vue&type=script&lang=js"

import "./SummaryFreemium.vue?vue&type=style&index=0&id=1f51a244&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f51a244"]])

export default __exports__